//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class BenefitItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { icon, text, className } = this.props;
    const componentClasses = classNames(styles.BenefitItem, {
      [className]: className,
    });

    return (
      <div className={componentClasses}>
        {icon}
        <h3 className={styles.Text}>{text}</h3>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(BenefitItem);
